import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState, lazy } from "react";
import { renderTemplateWithRouteState } from "../Product/renderTemplate";
import { useParsedQueryAndParams } from "@ploy-lib/routing";
import { useInvalidator, useResource } from "@rest-hooks/core";
import { AppLoadResource } from "@ploy-lib/rest-resources";
import { Typography } from "@material-ui/core";
import { AppActionProvider, FormStateProvider, useAppActionState } from "@ploy-ui/template-form";
import { useInRouterContext } from "react-router-dom";
const CalculationForm = lazy(() => import("@ploy-ui/calculation-form").then(m => ({
    default: m.CalculationForm
})));
const appLoadShape = AppLoadResource.detail();
export const ApplicationView = (props) => {
    const { externalPostback, ...rest } = props;
    return (_jsx(AppActionProvider, { externalPostback: externalPostback, children: _jsx(ApplicationViewInternal, { ...rest }) }));
};
export const ApplicationViewInternal = (props) => {
    const { disallowedFieldRoles, appLoadPayload } = props;
    const { formContext, context, applicationNumber, initialize = true, fromSubmit, customerContext, AuthorizationCode, FailedAuthorizationCode, scrollToTop } = useParsedQueryAndParams(props);
    const { formIsLiteral = false, formIsDisabled = false } = props;
    const [refetchCounter, setRefetchCounter] = useState(0);
    const [loadingApplicationAfterSubmission, setLoadingApplicationAfterSubmission] = useState(fromSubmit);
    const innerAppLoadPayload = useMemo(() => ({
        applicationNumber,
        fromSession: !initialize ? true : undefined,
        fromSubmit: loadingApplicationAfterSubmission,
        sblAuthCode: FailedAuthorizationCode || AuthorizationCode, // Altinn sends parameters "AuthorizationCode" when consent is accepted, or "FailedAuthorizationCode" when consent is rejected,
        sblRejected: FailedAuthorizationCode ? true : undefined,
        customerContext,
        ...appLoadPayload
    }), [
        applicationNumber,
        initialize,
        loadingApplicationAfterSubmission,
        FailedAuthorizationCode,
        AuthorizationCode,
        customerContext,
        appLoadPayload
    ]);
    const appLoad = useResource(appLoadShape, innerAppLoadPayload);
    const invalidateApp = useInvalidator(appLoadShape);
    const hasRouteState = useInRouterContext();
    const appAction = useAppActionState();
    const header = (_jsx(Typography, { style: { fontWeight: "bold" }, children: appLoad.productName }));
    const onSubmit = useCallback((values) => {
        const { __calculation: { submitResult } = {} } = values;
        if (submitResult && appAction.externalPostback)
            appAction.externalPostback(submitResult);
        // If the submit returned validation error messages (e.g. from the
        // VALIDATE_SAVE DT), do NOT invalidate/refetch the app.
        // Refreshing would remount the form and discard those messages
        // before they can be displayed to the user.
        if (submitResult?.VisibleMessages?.length > 0)
            return;
        setLoadingApplicationAfterSubmission(true);
        //Causes app and form refetch
        invalidateApp(innerAppLoadPayload);
        setRefetchCounter(refetchCounter + 1);
    }, [appAction, refetchCounter, invalidateApp, innerAppLoadPayload]);
    useEffect(() => {
        if (appLoad.externalRedirectUrl) {
            setTimeout(() => window.open(appLoad.externalRedirectUrl, "_parent"), 0);
        }
    }, [appLoad.externalRedirectUrl]);
    return applicationNumber ? (_jsx(FormStateProvider, { initialState: {
            formIsLiteral: formIsLiteral,
            formIsDisabled: formIsDisabled
        }, children: _jsx(CalculationForm, { applicationNumber: applicationNumber || "", appLoadPayload: innerAppLoadPayload, formContext: formContext, refetchCounter: refetchCounter, context: context, onSubmit: onSubmit, onSubmitError: onSubmit, customerContext: customerContext, skipInitialize: !initialize, header: appLoad.settings.alwaysShowProductName ? header : null, disallowedFieldRoles: disallowedFieldRoles, scrollToTop: scrollToTop, children: hasRouteState ? renderTemplateWithRouteState : undefined }) })) : null;
};
//# sourceMappingURL=ApplicationView.js.map